<template>

  <b-form class="mt-3" >
    <b-row>

      <b-col
        cols="12"
        md="6"
      >
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <InputFilter :filter="search[1]" />
      </b-col>

    </b-row>


    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        @click="onSearchBtnClicked"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>

</template>

<script>
import {
  BButton, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import InputFilter from '../../../../filters/components/InputFilter.vue'

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  // beforeMount(){
  // },
  setup(props) {

    const options = [
      { label: 'ทั้งหมด', code: null },
      { label: 'ใช้งาน', code: true },
      { label: 'ไม่ใช้งาน', code: false },
    ]

    const searchList = [
      {
        id: 'text', label: 'คำค้นหา', value: '', class: '', style: '', placeholder: 'คำค้นหา', type: 'text', options: [],
      },
      {
        id: 'isActive', label: 'สถานะการใช้งาน', value: '', class: '', style: '', placeholder: 'สถานะการใช้งาน', type: 'select', options,
      },
    ]


    return {
      options,
      search: searchList,
      props,
    }
  },
  methods: {
    onResetBtnClicked(){
       this.search[0].value=null
       this.search[1].value=null
       this.search[2].value=null
       this.search[3].value=null
       this.search[4].value=null
       this.search[5].value=null
    },
    onSearchBtnClicked() {
      var params = {};

      if(this.search[0].value || this.search[0].value === false)
         params.Description = this.search[0].value;
      if(this.search[1].value || this.search[1].value === false)
        params.IsActive = this.search[1].value;
      

      this.$emit('handleSubmit', params)


    }
  }
}
</script>
 <style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
